import { render, staticRenderFns } from "./t4.md?vue&type=template&id=19553907&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../usr/local/share/.config/yarn/global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports